"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var fluid = _a.fluid, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, 
    // xxl,
    screenClass = _a.screenClass, containerWidths = _a.containerWidths, marginWidths = _a.marginWidths;
    var styles = {
        boxSizing: 'border-box',
        position: 'relative',
        marginLeft: 'auto',
        marginRight: 'auto',
    };
    if (fluid && !xs && !sm && !md && !lg && !xl) {
        return __assign({}, styles);
    }
    if (screenClass === 'xs' && containerWidths[0] && !xs) {
        styles.maxWidth = containerWidths[0];
        styles.paddingLeft = marginWidths[0];
        styles.paddingRight = marginWidths[0];
    }
    if (screenClass === 'sm' && containerWidths[0] && !sm) {
        styles.maxWidth = containerWidths[0];
        styles.paddingLeft = marginWidths[0];
        styles.paddingRight = marginWidths[0];
    }
    if (screenClass === 'md' && containerWidths[1] && !md) {
        styles.maxWidth = containerWidths[1];
        styles.paddingLeft = marginWidths[1];
        styles.paddingRight = marginWidths[1];
    }
    if (screenClass === 'lg' && containerWidths[2] && !lg) {
        styles.maxWidth = containerWidths[2];
        styles.paddingLeft = marginWidths[2];
        styles.paddingRight = marginWidths[2];
    }
    if (screenClass === 'xl' && containerWidths[3] && !xl) {
        styles.maxWidth = containerWidths[3];
        styles.paddingLeft = marginWidths[3];
        styles.paddingRight = marginWidths[3];
    }
    // if (screenClass === 'xxl' && containerWidths[4] && !xxl) {
    //   styles.maxWidth = containerWidths[4];
    // }
    return __assign({}, styles);
});
//# sourceMappingURL=style.js.map